import React from 'react';

import {HeaderView} from '../views/Header/Header.view';
import {NonMeetingHeaderEndEnhancer} from '../views/NonMeetingHeaderEndEnhancer/NonMeetingHeaderEndEnhancer.view';

import {RegistrationMenu} from './RegistrationMenu.viewModel';
import {UserMenu} from './UserMenu.viewModel';

export const NonMeetingHeader: React.FC<{hasMedia?: boolean}> = ({
    hasMedia = false,
}) => (
    <HeaderView
        enhancerEnd={
            <NonMeetingHeaderEndEnhancer
                registrationMenu={<RegistrationMenu variant="translucent" />}
                userMenu={
                    <UserMenu hasMedia={hasMedia} variant="translucent" />
                }
            />
        }
    />
);
